import React from 'react';
import { Dayjs } from 'dayjs';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { t } from 'i18next';

interface Props {
  start: Dayjs;
  end: Dayjs;
  title: string;
  activityStatusData: [number, number, number | null][];
  isPrinting: boolean;
}

export const DatetimeActivityStatusGraph = React.memo(({ start, end, title, activityStatusData, isPrinting }: Props) => {
  const options: Highcharts.Options = {
    title: {
      text: '',
    },
    chart: {
      zoomType: 'x',
      height: 60,
      marginTop: 0,
      marginLeft: 108,
      marginRight: isPrinting ? 180 : 48,
      shadow: false,
      animation: false,
      backgroundColor: '#FFFFFF',
    },
    time: {
      timezoneOffset: new Date().getTimezoneOffset(),
    },
    xAxis: {
      type: 'datetime',
      min: start.valueOf(),
      max: end.valueOf(),
      dateTimeLabelFormats: {
        minute: '%H:%M',
        hour: '%H:00',
        day: t('graphDayFormat', '%m月%d日'),
        week: t('graphDayFormat', '%m月%d日'),
        month: t('graphYearFormat', '%m月%d日'),
      },
    },
    yAxis: {
      categories: [''],
      reversed: false,
      gridLineWidth: 0,
      title: { text: '' },
    },
    colorAxis: {
      min: 0,
      max: 7,
      // stopsの値は色コードは姿勢コード÷姿勢の総数で求めた値を入れる
      stops: [
        [0, '#FFF4CC'],
        [0.125, '#FFF4CC'],
        [0.25, '#000000'],
        [0.375, '#141F80'],
        [0.5, '#D7F5FF'],
        [0.625, '#5855DB'],
        [0.75, '#4EC1D0'],
        [0.875, '#B092E2'],
        [1, '#FF7152'],
      ],
    },
    series: [
      {
        type: 'heatmap',
        boostThreshold: 100,
        data: activityStatusData,
        colsize: 8.5 * 36e3,
        rowsize: 1,
        index: 0,
        turboThreshold: Number.MAX_VALUE,
        dataLabels: { enabled: false },
        tooltip: {},
      },
    ],
    tooltip: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    boost: {
      useGPUTranslations: true,
    },
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
});
